import {createAction} from 'Shared/utilities/actionCreator';
import {ContingentBeneficiaryList} from 'ApplicationEntry/models/ContingentBeneficiaryList';
import {ContingentBeneficiary} from 'ApplicationEntry/models/ContingentBeneficiary';
import * as C from '../models/ContingentBeneficiaryList';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import * as I from 'immutable';

export enum ContingentBeneficiaryListActionType {
  ADD_CONTINGENTBENEFICIARY = 'contingentBeneficiary/ADD_CONTINGENTBENEFICIARY',
  REMOVE_CONTINGENTBENEFICIARY = 'contingentBeneficiary/REMOVE_CONTINGENTBENEFICIARY',
  UPDATE_CONTINGENTBENEFICIARY = 'contingentBeneficiary/UPDATE_CONTINGENTBENEFICIARY',
}

export const addContingentBeneficiary = (contingentBeneficiary: I.List<ContingentBeneficiary>) =>
  createAction(ContingentBeneficiaryListActionType.ADD_CONTINGENTBENEFICIARY, {contingentBeneficiary});

export const removeContingentBeneficiary = (index: number) => {
  return createAction(ContingentBeneficiaryListActionType.REMOVE_CONTINGENTBENEFICIARY, {index});
};

export const updateContingentBeneficiary = (contingentBeneficiary: ContingentBeneficiary, index: number) => {
  return createAction(ContingentBeneficiaryListActionType.UPDATE_CONTINGENTBENEFICIARY, {contingentBeneficiary, index});
};

export type ContingentBeneficiaryListAction =
  | ReturnType<typeof addContingentBeneficiary>
  | ReturnType<typeof removeContingentBeneficiary>
  | ReturnType<typeof updateContingentBeneficiary>;

export const isContingentBeneficiaryListAction = (action: any): action is ContingentBeneficiaryListAction =>
  action.type in reverseEnum(ContingentBeneficiaryListActionType);

type ContingentBeneficiaryListState = ContingentBeneficiaryList;
const DEFAULT_STATE: ContingentBeneficiaryListState = C.EmptyContingentBeneficiaryList;

export default (
  state: ContingentBeneficiaryListState = DEFAULT_STATE,
  action: ContingentBeneficiaryListAction
): ContingentBeneficiaryListState => {
  switch (action.type) {
    case ContingentBeneficiaryListActionType.ADD_CONTINGENTBENEFICIARY:
      const {contingentBeneficiary} = action.payload;
      return C.addContingentBeneficiary(contingentBeneficiary)(state.contingentBeneficiaryList);
    case ContingentBeneficiaryListActionType.REMOVE_CONTINGENTBENEFICIARY:
      return C.removeContingentBeneficiary(action.payload.index)(state.contingentBeneficiaryList);
    case ContingentBeneficiaryListActionType.UPDATE_CONTINGENTBENEFICIARY:
      return C.updateContingentBeneficiary(
        action.payload.contingentBeneficiary,
        action.payload.index
      )(state.contingentBeneficiaryList);
    default:
      return state;
  }
};
